import Endpoints from 'constants/Endpoints';
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';

const getPoll = async (pollType) => {
    return await RestRequestGET(Endpoints.POLL_GET(pollType));
}

const savePollRating = async (rating) => {
    return await RestRequestPOST(Endpoints.POLL_SAVE_RATING(), rating);
}

export default {getPoll, savePollRating}